import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FaCog, FaArrowRight, FaAppleAlt, FaSeedling, FaHardHat, FaTruck, FaTshirt, FaFlask } from 'react-icons/fa';

const ICON_MAP = { FaAppleAlt, FaSeedling, FaHardHat, FaTruck, FaTshirt, FaFlask, FaCog };

export default function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/services').then(r => { setServices(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <div className="pt-20">
      {/* Header */}
      <div className="hero-gradient hero-pattern py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <nav className="text-sm text-gray-400 mb-4 flex justify-center gap-2">
            <Link to="/" className="hover:text-secondary">Ana Sayfa</Link>
            <span>/</span> <span className="text-white">Hizmetler</span>
          </nav>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Hizmetlerimiz</h1>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Farklı sektörlerin özel ihtiyaçlarına yönelik geliştirdiğimiz kapsamlı çözümler
          </p>
        </div>
      </div>

      {/* Services Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="card p-6 animate-pulse">
                <div className="w-14 h-14 bg-gray-200 rounded-xl mb-4" />
                <div className="h-5 bg-gray-200 rounded w-2/3 mb-3" />
                <div className="h-4 bg-gray-200 rounded mb-2" />
                <div className="h-4 bg-gray-200 rounded w-4/5" />
              </div>
            ))}
          </div>
        ) : services.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map(s => {
              const Icon = ICON_MAP[s.icon] || FaCog;
              return (
                <Link key={s.id} to={`/hizmetler/${s.slug}`}
                  className="card group p-6 hover:-translate-y-1 cursor-pointer">
                  <div className="w-16 h-16 bg-secondary/10 rounded-2xl flex items-center justify-center mb-5 group-hover:bg-secondary transition-colors duration-300">
                    <Icon className="text-secondary group-hover:text-white text-3xl transition-colors duration-300" />
                  </div>
                  <h3 className="text-xl font-semibold text-primary mb-3 group-hover:text-secondary transition-colors">{s.name}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed mb-5 line-clamp-3">{s.short_description}</p>

                  {Array.isArray(s.features) && s.features.length > 0 && (
                    <ul className="space-y-1.5 mb-5">
                      {s.features.slice(0, 3).map((f, i) => (
                        <li key={i} className="text-xs text-gray-500 flex items-center gap-2">
                          <span className="w-1.5 h-1.5 bg-secondary rounded-full flex-shrink-0" />
                          {f}
                        </li>
                      ))}
                    </ul>
                  )}

                  <div className="text-secondary text-sm font-semibold flex items-center gap-1 group-hover:gap-2 transition-all">
                    Detaylı Bilgi <FaArrowRight size={12} />
                  </div>
                </Link>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-20 text-gray-400">
            <FaCog size={64} className="mx-auto opacity-20 mb-4" />
            <p className="text-lg">Henüz hizmet eklenmemiş.</p>
          </div>
        )}
      </div>

      {/* CTA */}
      <div className="bg-gray-50 border-t py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-2xl font-bold text-primary mb-3">Özel Çözüm mü Arıyorsunuz?</h2>
          <p className="text-gray-500 mb-6">Sektörünüze özel ihtiyaçlarınız için uzman ekibimizle görüşün.</p>
          <Link to="/iletisim" className="btn-primary">
            İletişime Geçin <FaArrowRight />
          </Link>
        </div>
      </div>
    </div>
  );
}
